import { motion } from "framer-motion";

export const pageMotion = {
  initial: { opacity: 0, y: 18 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -12 },
  transition: { duration: 0.45, ease: [0.22, 1, 0.36, 1] },
};

export function Page({ children, testid }) {
  return (
    <motion.div {...pageMotion} data-testid={testid}>
      {children}
    </motion.div>
  );
}

export function Eyebrow({ children }) {
  return (
    <span className="font-mono-label text-xs tracking-[0.25em] uppercase text-[#C5A059]">
      {children}
    </span>
  );
}

export function PageHero({ eyebrow, title, subtitle, image, testid }) {
  return (
    <section className="relative overflow-hidden" data-testid={testid}>
      {image && (
        <>
          <img
            src={image}
            alt=""
            className="absolute inset-0 w-full h-full object-cover opacity-25"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0B132B]/70 via-[#0B132B]/85 to-[#0B132B]" />
        </>
      )}
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 py-24 lg:py-32">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-3xl"
        >
          <Eyebrow>{eyebrow}</Eyebrow>
          <h1 className="mt-5 font-serif-display text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight text-[#F8F9FA] leading-[1.05]">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-6 text-base sm:text-lg leading-relaxed text-[#A0AAB2] max-w-2xl">
              {subtitle}
            </p>
          )}
          <div className="gold-rule mt-10 w-40" />
        </motion.div>
      </div>
    </section>
  );
}
